import { $t } from "@/lib/i18nHelpers";

export const cards = [
  {
    image: {
      regular1x: "/img/landing/FeaturesBlock/discover.png",
      regular2x: "/img/landing/FeaturesBlock/discover@2x.png",
      webp1x: "/img/landing/FeaturesBlock/discover.webp",
      webp2x: "/img/landing/FeaturesBlock/discover@2x.webp",
    },
    text: {
      badge: $t("Discover"),
      titlePath: "Get discovered by top\xa0{accent}",
      titleAccent: "brands",
      description: $t("Produce high-quality content and\xa0monetize your engagement"),
    },
  },
  {
    image: {
      regular1x: "/img/landing/FeaturesBlock/monetize.png",
      regular2x: "/img/landing/FeaturesBlock/monetize@2x.png",
      webp1x: "/img/landing/FeaturesBlock/monetize.webp",
      webp2x: "/img/landing/FeaturesBlock/monetize@2x.webp",
    },
    text: {
      badge: $t("Monetize"),
      titlePath: "Monetize unique {accent}",
      titleAccent: "audience",
      description: $t("Earn revenue through tips, messages, paid posts and monthly subscriptions"),
    },
  },
  {
    image: {
      regular1x: "/img/landing/FeaturesBlock/stream.png",
      regular2x: "/img/landing/FeaturesBlock/stream@2x.png",
      webp1x: "/img/landing/FeaturesBlock/stream.webp",
      webp2x: "/img/landing/FeaturesBlock/stream@2x.webp",
    },
    text: {
      badge: $t("Stream"),
      titlePath: "Earn more with live {accent} & real-time calls",
      titleAccent: "streaming",
      description: $t("Use more opportunities for your audience to engage with you on a deeper level"),
    },
  },
  {
    image: {
      regular1x: "/img/landing/FeaturesBlock/analytics.png",
      regular2x: "/img/landing/FeaturesBlock/analytics@2x.png",
      webp1x: "/img/landing/FeaturesBlock/analytics.webp",
      webp2x: "/img/landing/FeaturesBlock/analytics@2x.webp",
    },
    text: {
      badge: $t("Analytics"),
      titlePath: "Track {accent} & statistics",
      titleAccent: "earnings",
      description: $t("Keep track of your monthly earnings and statistics with analytics"),
    },
  },
];
